import { countries } from "../../data/countries";
import { Country } from "../general/Country";

type BillingAddressProps = {
	id?: string;
	description?: string;
	firstLine?: string;
	secondLine?: string;
	city?: string;
	postalCode?: string;
	region?: string;
	country?: Country;
};

class BillingAddress {
	constructor(public _: BillingAddressProps) {}

	static fromJson(json: any) {
		return new BillingAddress({
			id: json.id,
			description: json.description,
			firstLine: json.first_line,
			secondLine: json.second_line,
			city: json.city,
			postalCode: json.postal_code,
			region: json.region,
			country:
				json.country_code && countries.getCountryByCode(json.country_code),
		});
	}

	toJson() {
		const res = {
			id: this._.id,
			description: this._.description,
			first_line: this._.firstLine,
			second_line: this._.secondLine,
			city: this._.city,
			postal_code: this._.postalCode,
			region: this._.region,
			country_code: this._.country?._.code,
		} as any;
		return res;
	}

	get displayText() {
		return [
			this._.firstLine,
			this._.secondLine,
			this._.city,
			this._.region,
			this._.postalCode,
			this._.country?.displayText,
		]
			.filter((x) => x)
			.join(", ");
	}

	copyWith(props: Partial<BillingAddressProps>) {
		return new BillingAddress({ ...this._, ...props });
	}
}

export { BillingAddress };
